module.exports = __webpack_public_path__ + "static/media/icon_ArrowUp.ece54cb2.svg";